export default {
  'report': 'Bericht',
  'new': 'neu',
  'sum': 'Summe',
  'time': 'Zeit',
  'quantity': 'Menge',
  'aggregated': 'Zusammengeführt',
  'detailed': 'detailiert',
  'showNAlarms': '<b>{0}</b> längste Alarmmeldungen anzeigen',
  'showNLongest': 'zeige <b>{0}</b> den längsten',
  'showOthers': 'zeige andere',
  'hideOthers': 'verberge andere',
  'sumOfSmaller': 'Summe anderer',
  'dropHereToCreateNew': 'Hierher ziehen und ablegen, um ein neues Diagramm zu erstellen',
  'completedOrders': 'abgeschlossene Aufträge',
  'history': 'Verlauf',
  'usedEnergy': 'verbrauchte Energie',
  'addPersonal': 'persönliches Dashboard',
  'addFactory': 'Standort Dashboard',
  'unitConversionNotComplete': 'Umrechnung der Einheit nicht abgeschlossen',
  'unitConversionComplete': 'Umrechnung der Einheit abgeschlossen',
  'unableToFullyConvertUnitMessage': 'Wir sind nicht in der Lage, die gesamte Produktion auf \'{Einheit}\' umzurechnen, die Verpackungsstruktur von SKUs muss geprüft werden, die in diesem Zeitraum produziert wurden',
  'work': 'Arbeit',
  'plannedDowntime': 'geplant',
  'unplannedDowntime': 'ungeplant',
  'expected': 'erwartet',
  'rootElement': 'Basiselement',
  'performanceImpact': 'Leistungsverlust',
  'availabilityImpact': 'Verfügbarkeitsverlust',
  'utilizationImpact': 'Nutzen Verlust',
  'minorStops': 'Kleinstörungen',
  'oeeLoss': {
    'oeeLoss': 'OEE Verlust',
    'productionLoss': 'Produktionsverlust',
    'undefinedIssue': 'Art des Problems undefiniert',
    'utilizationLosses': 'geplante Verluste',
    'availabilityLosses': 'Verfügbarkeitsverluste',
    'performanceLosses': 'Leistungsverluste',
    'qualityLosses': 'Qualitätsverluste',
    'speedLoss': 'Geschwindigkeitsverlust',
    'qualityLoss': 'Qualitätsverlust',
    'speedIncrease': 'Geschwindigkeitsgewinn',
    'combined': 'kombiniert',
    'byMachine': 'unterteilt in Linien / Anlagen',
    'byProblem': 'Unterteilt in Probleme',
    'byState': 'Unterteilt in Zustände',
    'base': 'dargestellte Ausgangszeit',
    'time': {
      'totalTime': 'gesamt verfügbare Zeit',
      'scheduledTime': 'geplante Produktionszeit',
      'operatingTime': 'tatsächliche Produktionszeit',
      'productionTime': 'verfügbare Produktionszeit',
      'effectiveTime': 'effektive Produktionszeit'
    },
    'performanceStops': 'Leistungsverluste Standzeiten',
    'qualityStops': 'Qualitätsverluste Standzeiten',
    'calculatedBasedOnTotalAvailabilityLoss': 'Kalkuliert basierend auf Verfügbarkeitsverlusten'
  },
  'select': {
    'allLines': 'alle Linien',
    'allMachines': 'alle Maschinen',
    'selectMachine': 'wähle Maschine aus',
    'selectLine': 'wähle Linie aus',
    'clear': 'lösche',
    'selectLineAreaOrPlant': 'Werk, Linie oder Bereich auswählen'
  },
  'alarms': {
    'description': 'Beschreibung',
    'numberOfOccurances': 'Nummer',
    'duration': 'Dauer',
    'sumOfSmallerAlarms': 'Summe kleiner Alarme',
    'noDataInThisPeriod': 'keine Daten in dieser Periode'
  },
  'selectors': {
    'period': 'Periode',
    'moment': 'Moment',
    'dateTo': 'Datum bis',
    'dateFrom': 'Daum von',
    'shift': 'Schicht',
    'day': 'Tag',
    'week': 'Woche',
    'month': 'Monat',
    'today': 'Heute',
    'yesterday': 'Gestern',
    'thisWeek': 'diese Woche',
    'previousWeek': 'vorherige Woche',
    'thisMonth': 'dieser Monat',
    'previousMonth': 'vorheriger Monat',
    'selectLineAndMachine': 'wähle Linie und Maschine aus',
    'selectLine': 'Wähle Linie',
    'selectLineOrMachine': 'Wähle Linie oder Maschine',
    'timeFilter': 'Zeit Filter',
    'lastThreeMonths': 'Letzten 3 Monate',
    'selectExactDates': 'Wähle genaues Datum aus',
    'selectDatesFromList': 'Wähle Datum aus Liste aus',
    'addElement': 'Füge Standortelement zu dem Bericht hinzu',
    'amount': 'Menge'
  },
  'types': {
    'custom': 'Benutzerdefiniert',
    'availability': 'Verfügbarkeit',
    'efficiency': 'Effizienz',
    'oee': 'OEE',
    'oeeLosses': 'OEE Verluste',
    'oeeDetails': 'OEE Details',
    'production': 'Produktion',
    'productionMap': 'Produktionsplan',
    'downtimes': 'Stillstände',
    'rootcauses': 'Ursachen für Stillstände',
    'alarms': 'Alarme',
    'column': 'Säule',
    'pie': 'Kuchen',
    'operatorStops': 'Bediener stoppt',
    'downtimeDuration': 'Stillstanddauer',
    'downtimeDurations': 'Stillstanddauern',
    'reasons': 'Ursachen',
    'energy': 'Energie',
    'energySankey': 'Sankey',
    'energyHistory': 'Nutzungsverlauf',
    'heatmap': 'Wärebild',
    'commentsFromLosses': 'Kommentare von Verlusten',
    'typeOfLosses': 'Art der Verluste',
    'reportsDownload': 'Bericht Download'
  },
  'operatorStop': {
    'waiting': 'Warten auf eine Aktion',
    'fixing': 'Aktionsdauer',
    'stopsBecauseOf': 'stoppt wegen',
    'timeSum': 'Gesamtdauer'
  },
  'rootcause': {
    'impact': {'title': 'Auswirkung', 'desc': '(Wirkungsdauer / Ursachendauer)'},
    'effectDuration': 'Wirkungsdauer',
    'rootcauseDuration': 'Ursachendauer'
  },
  'chart': {'toggleFullView': 'auf Vollansicht umschalten'},
  'chooseEvent': 'Problem auswählen',
  'needToSelectEvent': 'Sie müssen das Problem auswählen',
  'splitBy': 'Aufgeteilt in',
  'minorStopsIncluded': 'Kleinstörungen (in Gesamtdauer enthalten)',
  'detailedEventsReport': 'Detailierter Ereignisbericht',
  'siteOeeReport': 'Standort OEE Bericht',
  'speedLossReport': 'Geschwindigkeit Verlust Bericht',
  'labourVarianceReport': 'Arbeitsstundenbericht',
  'siteWeeklyScorecard': 'wöchentliche Kennzahlen des Standortes',
  'siteMonthlyScorecard': 'monatliche Kennzahlen des Standortes',
  'exportReport': 'Bericht exportieren',
  'excludeUtilizationLoss': 'geplante Verluste ausschließen'
};
